/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_Bullet_HandoverInputs */

const en_marketing_engagement_bullet_handover = /** @type {(inputs: Marketing_Engagement_Bullet_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full handover: code, infra, knowledge`)
};

const es_marketing_engagement_bullet_handover = /** @type {(inputs: Marketing_Engagement_Bullet_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega completa: código, infraestructura y conocimiento`)
};

const fr_marketing_engagement_bullet_handover = /** @type {(inputs: Marketing_Engagement_Bullet_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfert complet : code, infrastructure, savoir-faire`)
};

/**
* | output |
* | --- |
* | "Full handover: code, infra, knowledge" |
*
* @param {Marketing_Engagement_Bullet_HandoverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_bullet_handover = /** @type {((inputs?: Marketing_Engagement_Bullet_HandoverInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_Bullet_HandoverInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_bullet_handover(inputs)
	if (locale === "es") return es_marketing_engagement_bullet_handover(inputs)
	return fr_marketing_engagement_bullet_handover(inputs)
});